import { useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { Button, Modal, ModalBody } from "reactstrap";
import { Href, VideoCallHangTitle } from "../../../../Constants/Constants";
import { dynamicImage, dynamicNumber, Image } from "../../../../Utils";
import { Phone, Video } from "react-feather";

const VideoCallHang = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  return (
    <Fragment>
      <Button color="primary" className="fonts font_label" onClick={toggle}>{VideoCallHangTitle}</Button>
      <Modal isOpen={modal} fade toggle={toggle} centered className="viddiolog">
        <ModalBody>
          <div className="videocallhang call-modal bg-size" style={{ backgroundImage: `url(${dynamicImage(`avtar/big/videocall_bg.jpg`)})`, backgroundSize: "cover", backgroundPosition: "center center", display: "block" }}>
            <Image className="bg-img" src={dynamicImage("avtar/big/videocall_bg.jpg")} alt="Avatar" style={{ display: "none" }}/>
            <div className="d-flex videocall-details">
              <div className="usersprof">
                {dynamicNumber(2).map((item, index) => (
                  <div className="profile bg-size" key={index} style={{ backgroundImage: `url(${dynamicImage(`avtar/${item + 1}.jpg`)})`, backgroundSize: "cover", backgroundPosition: "center center", display: "block" }}>
                    <Image className="bg-img" src={dynamicImage(`avtar/${item + 1}.jpg`)} alt="Avatar" style={{ display: "none" }}/>
                  </div>
                ))}
              </div>
              <div className="media-body">
                <h5>Josephin water</h5>
                <h6>America ,California</h6>
              </div>
              <div className="red-notification">
                <div className="dot-btn dot-danger grow" />
                <h6>Ringing</h6>
              </div>
              <div className="zoomcontent">
                <a className="text-dark" href={Href}><Image src={dynamicImage("logo/maximize.svg")} alt="zoom screen" /></a>
              </div>
            </div>
            <div className="center-con text-center">
              <ul>
                <li><a className="icon-btn btn-success button-effect btn-xl is-animating" href={Href}><Video /></a></li>
                <li><a className="icon-btn btn-danger button-effect btn-xl is-animating cancelcall" href={Href} onClick={toggle}><Phone /></a></li>
              </ul>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default VideoCallHang;
